/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type signOutMutationVariables = {};
export type signOutMutationResponse = {
    readonly licensingAccountSignOut: {
        readonly wasSuccessful: boolean;
    } | null;
};
export type signOutMutation = {
    readonly response: signOutMutationResponse;
    readonly variables: signOutMutationVariables;
};



/*
mutation signOutMutation {
  licensingAccountSignOut {
    wasSuccessful
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "LicensingSignOut",
            "kind": "LinkedField",
            "name": "licensingAccountSignOut",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "signOutMutation",
            "selections": (v0 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "signOutMutation",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "d7e0c63497ea93174ca556a91fa84690",
            "id": null,
            "metadata": {},
            "name": "signOutMutation",
            "operationKind": "mutation",
            "text": "mutation signOutMutation {\n  licensingAccountSignOut {\n    wasSuccessful\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '293c0d4db8f568708fb6a24c0c8a9db0';
export default node;
